import axios from "axios";
const API = `${process.env.REACT_APP_API_BASE_URL || "http://localhost:8080"}/api/vaccination-rules`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("authToken") || ""}` });
export async function createVaccinationRule(body) {
  return (await axios.post(API, body, { headers: auth() })).data;
}
